module.exports = __webpack_public_path__ + "img/white-background-ar-mobile.5452989.png";